import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { FlatList, Pressable, Text, View } from "react-native";
import { black, color_main, ColorLine, white } from "../../assets/style/colors";
import React, { useEffect, useState } from "react";
import { BottomButtonView } from "../../components/BottomButtonView";
import { useIsFocused } from "@react-navigation/native";
import { tipoffList, tipoffSubmit } from "../../net/service";
import { ListEmpty } from "../../components/ListEmpty";
import { MainNavProps } from "../navigation/main/MainParamList";
import { showDialog } from "../../components/CommonDialog";
import {
  Str_NextStep,
  Str_Report,
  Str_ReportSuc,
} from "../../language/string_res";
import { hideLoading, showLoading } from "../../components/Loading";
import { CheckBoxView } from "../../components/CheckBoxView";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";

export const Report = ({ navigation, route }: MainNavProps<"Report">) => {
  const { uid, tid } = route.params;
  const isFocused = useIsFocused();
  const [list, setList] = useState<string[]>([]);
  const [selects, updateSelects] = useState<string[]>([]);

  useEffect(() => {
    tipoffList().then((res) => {
      if (res.data && res.data.contents) {
        setList(res.data.contents);
      }
    });
  }, [isFocused]);

  function handleOnclick(item: string) {
    const index = selects.indexOf(item);
    if (index > -1) {
      selects.splice(index, 1);
    } else {
      selects.push(item);
    }
    updateSelects([...selects]);
  }

  interface ReportRequest {
    tid?: string;
    uid?: number;
  }

  function handleDoReport() {
    const request: ReportRequest = {
      tid: tid,
      uid: uid,
    };
    const target = JSON.stringify(request);
    let body = { target: target, contents: selects };
    showLoading("");
    tipoffSubmit(body)
      .then((res) => {
        if (res.code === 0) {
          showDialog({
            message: Str_ReportSuc,
            onConfirm: () => {
              navigation.goBack();
            },
          });
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  const ReportItem = ({ item }: { item: string; index: number }) => {
    return (
      <Pressable
        onPress={() => handleOnclick(item)}
        style={{
          flexDirection: "row",
          paddingVertical: 14,
          alignItems: "center",
          paddingStart: 16,
          backgroundColor: white,
          justifyContent: "space-between",
        }}
      >
        <Text style={{ fontSize: 14, color: black }}>{item}</Text>
        <CheckBoxView
          disabled={false}
          value={selects.includes(item)}
          onValueChange={() => handleOnclick(item)}
          style={{ width: 15, height: 15, marginEnd: 16 }}
        />

        <View
          style={{
            height: 1,
            position: "absolute",
            zIndex: 999,
            width: "100%",
            bottom: 0,
            backgroundColor: ColorLine,
          }}
        />
      </Pressable>
    );
  };

  return (
    <ScreenCloseModal title={Str_Report}>
      <FlatList
        style={{ marginTop: 18, marginHorizontal: 10, borderRadius: 5 }}
        data={list}
        keyExtractor={(item) => item.toString()}
        ListEmptyComponent={<ListEmpty />}
        renderItem={ReportItem}
      />
      <BottomButtonView text={Str_NextStep} onClick={handleDoReport} />
    </ScreenCloseModal>
  );
};
